import * as common from "./common";

import * as core from "./core";

import * as signerSession from "./signer-session";

/** Versão atual necessária para o processo de assinatura
 */
let requiredVersion: common.RequiredVersionInfo = {
    applet: "0.8.0",
    chrome: "0.4.2",
    gecko: "0.4.4",
    host: "0.7.0"
};

window["QuickSoft"] = (function(ns) 
{
    if (!ns.Signer) ns.Signer = { }; 
    let signerNS = ns.Signer;

    window["__QuickSoft_DigitalSignature_Web_SignerCore_notifyAppletReady"]    = core.__QuickSoft_DigitalSignature_Web_SignerCore_notifyAppletReady;
    window["__QuickSoft_DigitalSignature_Web_SignerCore_handleAppletResponse"] = core.__QuickSoft_DigitalSignature_Web_SignerCore_handleAppletResponse;

    signerNS.VersionBindings = requiredVersion;

    signerNS.checkVersion        = common.checkVersion;
    signerNS.combineRequirements = common.combineRequirements;
    signerNS.checkWebExtRuntimeVersions = common.checkWebExtRuntimeVersions;
    
    signerNS.VersionCheckError   = common.VersionCheckError;
    signerNS.CoreConstants       = common.CoreConstants;
    signerNS.RequestIdGenerator  = common.RequestIdGenerator;
    
    signerNS.SignerCore                      = core.SignerCore;
    signerNS.SupportedPlatform               = core.SupportedPlatform;
    signerNS.IFrameContainerWebExtMessageHub = core.IFrameContainerWebExtMessageHub;

    signerNS.CertificateCache      = signerSession.CertificateCache;
    signerNS.SignerSession         = signerSession.SignerSession;
    signerNS.SignerSessionState    = signerSession.SignerSessionState;
    signerNS.CertificateCacheState = signerSession.CertificateCacheState;

    return ns;
})(window["QuickSoft"] || {});



// WEBPACK FOOTER //
// ./lib/index.ts